import logo from '../logo.svg';
import { Typography, Paper, AppBar, Button, Box, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Link, Toolbar, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

      <ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="subPageContainer">        
     
          <Typography variant='h1' className='sectionTitle'>Vereine</Typography>

          <Box className='subpageBodyBox'>
          <Typography variant='h2' className='sectionTitle2 subsection'>Verein gründen</Typography>
          <Typography variant='body1' className='sectionText textTwoColumns'>
          Einen Verein müssen mindestens sieben Personen gründen. Die Satzung des Vereins können sie schriftlich schließen. Anschließend reicht der Vorstand die Anmeldung zum Vereinsregister über einen Notar beim zuständigen Amtsgericht ein. Bitte stimmen Sie unbedingt den Entwurf der Satzung vor der Gründungsversammlung mit dem Finanzamt ab. Denn häufig beanstandet das Vereinsregister einzelne Satzungsbestimmungen. Außerdem muss die Satzung bestimmen Anforderungen genügen, damit das Finanzamt dem Verein den Status der Gemeinnützigkeit verleihen wird.
          </Typography>
          <Button className='btnSecondary'><HashLink smooth to="#">Verein online gründen</HashLink></Button>
        </Box>

        <hr className='hoeizontalLine' />

        <Box className='subpageBodyBox'>
          <Typography variant='h2' className='sectionTitle2 subsection'>Vereinsvorstand wechseln</Typography>
          <Typography variant='body1' className='sectionText textTwoColumns'>
          Wechselt der Vereinsvorstand, muss diese Änderung in das Vereinsregister eingetragen werden. Der Notar bereitet die entsprechende Anmeldung zum Vereinsregister vor und lässt den neuen Vorstand die Anmeldung unterschreiben.
          </Typography>
          <Button className='btnSecondary'><HashLink smooth to="#">Verein online ändern</HashLink></Button>
        </Box>

      </Container>


      <Box className="section bannergrey" id="kontakt">
        <Container maxWidth="lg" className="container" id="kontakt">
          <Box className="kontaktGrid">
            <Box className="kontaktLeftSide">
              <Typography variant='h2' className='sectionTitle white'>
                Sie haben Fragen?  <br />
                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
              </Typography>
              <Typography variant='body1' paragraph className='whiteText'>
                Harbecke & Thelen Notare<br />
                Holzgasse 29 - 33<br />
                Siegburg 53721<br />
              </Typography>
            </Box>
            <Contactform />
          </Box>
        </Container>
      </Box>


    </main >
    <Footer />
    </div >
  );
}

export default Imprint;